import React, { ComponentProps } from 'react';
import { ImageTypes, ProfileImage } from '../../../types/api/ImageType';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

import { asFetchableView, useViewContext } from '../../../_lib/ViewFetcher';
import { ImageUploadForm } from '../../../_lib/components/ImageUpload/ImageUploadForm';
import { HiddenParam, SonForm, TextParam } from '../../../_lib/Form2';
import { NestedParam } from '../../../_lib/Form2/types/NestedParam';
import { ImageFileParam } from '../../../_lib/Form2/types/FileUploadParam';

type ProfileImageEditProps = {
  image: ProfileImage;
  cropping: boolean;
  viewportSwitch: boolean;
  form: SonForm<
    NestedParam<
      'imageuploadparams',
      'imageupload',
      | ImageFileParam<'image'>
      | HiddenParam<'width'>
      | HiddenParam<'height'>
      | HiddenParam<'y'>
      | HiddenParam<'x'>
      | TextParam<'alt'>
      | TextParam<'copyright'>
      | TextParam<'caption'>
    >
  >;
};

export function ProfileImageEdit({ image, form, cropping, viewportSwitch }: ProfileImageEditProps) {
  const { uuid } = useBlockContext();
  const { refresh } = useRefreshBlock();
  const { t } = useSonTranslation('ProfileImage');
  const { fetchUrl } = useViewContext();

  return (
    <ImageUploadForm
      imageDescriptionName={t('imageDescriptionName')}
      responsiveType="userProfile"
      imageType={ImageTypes.profileImage}
      cropping={cropping}
      viewportSwitch={viewportSwitch}
      form={form}
      formId="profile-image-upload-form"
      uuid={uuid}
      initialImage={image}
      refresh={refresh}
      fetchUrl={fetchUrl}
      additionalDescription={t(`additionalDescription`)}
    />
  );
}

export const ProfileImageEditView = asFetchableView(ProfileImageEdit);
export type ProfileImageEditView = ComponentProps<typeof ProfileImageEditView>;
